import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _find from 'lodash/find';
import _get from 'lodash/get';
import { Coupon } from 'commons/models/coupon';

import { AppContext } from 'commons-ui';

import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { UserlistData } from '../../utils/constants';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateCoupon, requestAddUserlist } = useService();

	const updateCoupon = (updatedData: { couponData: Coupon; userListData?: UserlistData }) => {
		setShowLoader(true);

		const { couponData, userListData } = updatedData;

		requestUpdateCoupon(app.appName, couponData).then(
			(res: any) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while updating the coupon', { type: 'error' });

					setShowLoader(false);
					return;
				}

				if (userListData) {
					requestAddUserlist(app.appName, userListData).then(
						(userlistRes) => {
							const error = _find(userlistRes, (item) => item.status !== 200 || !item.data.success);
							if (error) {
								showAlert(
									`Error: Coupon was successfully updated. Error occured while adding userlist. Please edit the coupon to add the list again`,
									{ type: 'error' }
								);
							} else {
								showAlert('Record updated');
							}
							setShowLoader(false);
							history.goBack();
						},
						() => {
							showAlert(
								`Error: Coupon was successfully updated. Error occured while adding userlist. Please edit the coupon to add the list again`,
								{ type: 'error' }
							);
							setShowLoader(false);
							history.goBack();
						}
					);
				} else {
					showAlert('Record updated');
					setShowLoader(false);
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err.response.data.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
	};

	const handleFormSubmit = (submittedData: any) => {
		updateCoupon(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: hydrateFormData(_get(location, ['state', 'rowData'])),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useEdit;
